import { createSlice } from '@reduxjs/toolkit'
import { format } from 'date-fns'

import history from '@/config/router/history'
import { PATHS } from '@/config/router/routes'
import { startAppListening } from '@/config/store/listenerMiddleware'
import { authApi } from '@/ducks/auth/api/auth.api'
import {
  readFromLocalStorage,
  removeFromLocalStorage
} from '@/services/localStorage'
import { setClarityPostLogin } from '@/utils/clarity.utils'
import { logFirebaseEvent } from '@/utils/firebase.utils'

export interface AuthState {
  token?: string | null
}

export const initialState = {
  token: undefined
}
const initializeState = (): AuthState => ({
  token: readFromLocalStorage('token') || undefined
})

const authSlice = createSlice({
  name: 'auth',
  initialState: initializeState,
  reducers: {
    logout: () => {
      return { ...initialState }
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      authApi.endpoints.login.matchFulfilled,
      (state, { payload }) => {
        state.token = payload.token
        console.log(payload.id)
      }
    )
  }
})

startAppListening({
  actionCreator: authSlice.actions.logout,
  effect: async function syncStorage() {
    removeFromLocalStorage('token')

    history.push(PATHS.LOGIN)
  }
})

startAppListening({
  matcher: authApi.endpoints.login.matchFulfilled,
  effect: async action => {
    history.push(PATHS.ORDERS)

    if (action?.payload?.id) {
      logFirebaseEvent('AC_Web_ActivatedAccount', {
        Event_Time: format(new Date(), 'dd/MM/yyyy - HH:mm:ss'),
        Store_ID: action.payload.id
      })

      setClarityPostLogin({
        storeId: action.payload.id,
        storeType: action.payload.type,
        currencyCode: action.payload.currencyCode
      })
    }
  }
})

export const { logout } = authSlice.actions

export const authInitialState = initialState
export default authSlice.reducer
